unwrapQueryRef